"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGeneratorFunction = void 0;
const prepare_spec_1 = require("./prepare-spec/prepare-spec");
const object_properties_1 = require("./lib/object-properties");
const json_compare_1 = require("./lib/json-compare");
const systemState = Object.getOwnPropertyNames(Math).reduce((soFar, key) => {
    // @ts-ignore
    if (typeof Math[key] === 'function') { // @ts-ignore
        soFar._fns[key] = soFar._fns[`_Math_${key}`] = Math[key];
    }
    else { // @ts-ignore
        soFar[`_Math_${key}`] = Math[key];
    }
    return soFar;
}, { _fns: {} });
let depChangeCache = {};
function depsHaveChanged(oldState, newState, deps, clearCache) {
    if (clearCache)
        depChangeCache = {};
    return deps.some((dep) => {
        if (depChangeCache[dep] === undefined) {
            const oldDepValue = (0, object_properties_1.getObjectProperty)(oldState, dep, {});
            const newDepValue = (0, object_properties_1.getObjectProperty)(newState, dep, {});
            depChangeCache[dep] = !(0, json_compare_1.jsonCompare)(newDepValue, oldDepValue);
        }
        return depChangeCache[dep];
    });
}
/* Give the value generator a list of Value Specs and a lookup of the other Specs and functions,
   the values might need. It returns a function that you call to generate state.

   Usage:
     const getState = getGeneratorFunction(values, lookup);
     const {state, errors} = getState(patch, fallbackValues);

   patch: Values you want to set. e.g. { num1: 12 }
   fallbackValues: E.g. to pass in the previous state, so values can be re-used rather than regenerated.
*/
function getGeneratorFunction(values = [], lookups) {
    var _a;
    lookups.values = values;
    systemState._fns = Object.assign(Object.assign({}, systemState._fns), ((_a = lookups === null || lookups === void 0 ? void 0 : lookups.systemFunctions) !== null && _a !== void 0 ? _a : {}));
    lookups.systemFunctions = systemState._fns;
    const preparedValues = (0, prepare_spec_1.prepareSpec)(values, lookups);
    return function (patch = {}, fallbackValues = {}) {
        var _a;
        const oldValues = (_a = fallbackValues.state) !== null && _a !== void 0 ? _a : fallbackValues;
        const initialState = {
            state: Object.assign(Object.assign({}, systemState), oldValues),
            errors: [],
        };
        for (const [key, value] of Object.entries(patch)) {
            initialState.state = (0, object_properties_1.setObjectProperty)(initialState.state, key, value);
        }
        const result = preparedValues.reduce((soFar, value, i) => {
            const { name, dependencies } = value;
            if (depsHaveChanged(oldValues, soFar.state, [...dependencies], i === 0)
                || (0, object_properties_1.getObjectProperty)(oldValues, name, {}) === undefined) {
                try {
                    const result = value.fn(soFar.state, soFar.errors.map((e) => e.name));
                    if (value.type === 'error')
                        soFar.errors.push({
                            name,
                            messages: result
                                .split('~§~')
                                .map((message) => (message)),
                        });
                    else
                        soFar.state = (0, object_properties_1.setObjectProperty)(soFar.state, name, result);
                }
                catch (error) {
                    const err = error;
                    soFar.errors.push({
                        name,
                        messages: err.message.split('~§~'),
                    });
                }
            }
            return soFar;
        }, initialState);
        // Remove system-injected values.
        for (const key of Object.keys(systemState)) {
            delete result.state[key];
        }
        return result;
    };
}
exports.getGeneratorFunction = getGeneratorFunction;
